import { render, staticRenderFns } from "./UtmContentReportTable.vue?vue&type=template&id=0181d6a4&scoped=true&"
import script from "./UtmContentReportTable.vue?vue&type=script&lang=js&"
export * from "./UtmContentReportTable.vue?vue&type=script&lang=js&"
import style0 from "./UtmContentReportTable.vue?vue&type=style&index=0&id=0181d6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0181d6a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VDataTable,VRow,VTextField,VTooltip})
